module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-MediumItalic-a449cac2801d499acfedb9b09e5d6a97.woff2";